export default () => ({
  selectedTopic: {
    id: 1,
  },
});
